
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaUsers, FaUser, FaUniversity, FaFileInvoice,  FaSignOutAlt, FaBars, FaTimes, FaCogs,FaExchangeAlt } from 'react-icons/fa';

/*
const menuItems = [
    { icon: FaHome, text: 'Dashboard', path: '/home' },
    { icon: FaUsers, text: 'Usuarios', path: '/home/usuarios' },
    { icon: FaUser, text: 'Terceros**', path: '/home/terceros' },
    { icon: FaUniversity, text: 'Bancos **', path: '/home/bancos' },
    { icon: FaFileInvoice, text: 'Facturas**', path: '/home/facturas' },
    { icon: FaCalendarAlt, text: 'Ejercicios', path: '/home/ejercicios' },
    { icon: FaUniversity, text: 'Tipos', path: '/home/tipos'}
];

*/

const menuItems = [
    { icon: FaHome, text: 'Dashboard', path: '/home' },
    { icon: FaUsers, text: 'Usuarios', path: '/home/usuarios' },
    { icon: FaUser, text: 'Terceros ', path: '/home/terceros' },
    { icon: FaUniversity, text: 'Sepulturas ', path: '/home/sepulturas' },
    { 
        icon: FaFileInvoice, 
        text: 'Tramitador', 
        path: '/home',
        submenu: [
            { icon:FaFileInvoice, text: 'Concesiones', path: '/home/concesiones' },
            { icon:FaFileInvoice, text: 'Permiso de sepultura', path: '/home/permisos' },
            { icon:FaFileInvoice, text: 'Cambio de titularidad', path: '/home/titulares' },
            { icon:FaFileInvoice, text: 'Permiso de traslado ', path: '/home/traslados' },
            { icon:FaFileInvoice, text: 'Clausurar sepultura', path: '/home/clausurados' },
            { icon:FaFileInvoice, text: 'Liquidaciones', path: '/home/liquidaciones' },
        ]
    },
 /*   { 
        icon: FaExchangeAlt, 
        text: 'Solicitudes', 
        path: '/home',
        submenu: [
            { icon:FaExchangeAlt, text: 'Conexión Registro de entrada', path: '/' },
           // { icon:FaExchangeAlt, text: 'Prorrogas', path: '/' },
           // { icon:FaExchangeAlt, text: 'Traslados', path: '/' },
           // { icon:FaExchangeAlt, text: 'Renovación ', path: '/' },
           // { icon:FaExchangeAlt, text: 'Cambios de titular', path: '/' },
           // { icon:FaExchangeAlt, text: 'Renuncia', path: '/' },
        ]
    },
   */
    { 
        icon: FaCogs, 
        text: 'Configuracion', 
        path: '/home',
        submenu: [
            { icon:FaCogs, text: 'Tipos', path: '/home/tipos' },
            {
                icon: FaCogs, 
                text: 'Divisiones', 
                path: '/home/',
                submenu: [
                    { icon:FaCogs, text: 'Sector', path: '/home/lugares' },
                    { icon:FaCogs, text: 'Area', path: '/home/divisiones' },
                    { icon:FaCogs, text: 'Zona', path: '/home/subdivisiones' },
                ]   
            },
            { icon:FaCogs, text: 'Tasas', path: '/home/tasas' },
            { icon:FaCogs, text: 'Bancos', path: '/home/bancos' },
            { icon:FaCogs, text: 'Mapas', path: '/home/mapas' },
            { icon:FaCogs, text: 'Localizador QR', path: '/home/localizadores' },
            { icon:FaCogs, text: 'Ejercicios', path: '/home/ejercicios' },
            { icon:FaCogs, text: 'Entidad', path: '/home/entidad' },
            
        ]
    }
];

function Sidebar({ toggleSidebar, isSidebarOpen, handleLogout }) {
    const [openSubmenus, setOpenSubmenus] = useState({});

    const toggleSubmenu = (text) => {
        setOpenSubmenus((prev) => ({ ...prev, [text]: !prev[text] }));
    };

    return (
        <div className={`bg-gradient-to-b from-blue-700 to-blue-800 text-white h-screen ${isSidebarOpen ? 'w-64' : 'w-20'} transition-all duration-300 ease-in-out fixed left-0 top-0 z-50 flex flex-col shadow-lg`}>
            <div className="p-4 border-b border-blue-700">
                <h2 className={`text-2xl font-bold mb-4 ${isSidebarOpen ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}>Nekros</h2>
                <button onClick={toggleSidebar} className="text-white p-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50 flex items-center justify-center">
                    {isSidebarOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
                </button>
            </div>
            <nav className="flex-grow overflow-y-auto">
                <ul className="space-y-2 p-4">
                    {menuItems.map((item) => (
                        <li key={item.text}>
                            <div className="relative">
                                <NavLink to={item.path} end={!item.submenu} className={({ isActive }) => `flex items-center p-3 rounded-lg transition-all duration-200 ease-in-out ${isActive ? 'bg-blue-700 text-white' : 'text-blue-100 hover:bg-blue-700 hover:text-white'}`} onClick={item.submenu ? () => toggleSubmenu(item.text) : null}>
                                    <item.icon className={`h-5 w-5 ${isSidebarOpen ? 'mr-3' : 'mx-auto'}`} />
                                    <span className={`${isSidebarOpen ? 'opacity-100' : 'opacity-0 w-0'} transition-all duration-200`}>{item.text}</span>
                                    {item.submenu && <span className="ml-auto">{openSubmenus[item.text] ? '▲' : '▼'}</span>}
                                </NavLink>
                                {item.submenu && openSubmenus[item.text] && (
                                    <ul className={`ml-6 mt-2 space-y-2 ${isSidebarOpen ? '' : 'hidden'}`}>
                                        {item.submenu.map((subItem) => (
                                            <li key={subItem.text}>
                                                <NavLink to={subItem.path} className={({ isActive }) => `flex items-center p-2 rounded-lg transition-all duration-200 ease-in-out ${isActive ? 'bg-blue-600 text-white' : 'text-blue-100 hover:bg-blue-700 hover:text-white'}`} onClick={subItem.submenu ? () => toggleSubmenu(subItem.text) : null}>
                                                    <subItem.icon className="h-4 w-4 mr-3" />
                                                    <span>{subItem.text}</span>
                                                    {subItem.submenu && <span className="ml-auto">{openSubmenus[subItem.text] ? '▲' : '▼'}</span>}
                                                </NavLink>
                                                {subItem.submenu && openSubmenus[subItem.text] && (
                                                    <ul className="ml-6 mt-2 space-y-2">
                                                        {subItem.submenu.map((nestedItem) => (
                                                            <li key={nestedItem.text}>
                                                                <NavLink to={nestedItem.path} className="flex items-center p-2 rounded-lg transition-all duration-200 ease-in-out text-blue-100 hover:bg-blue-700 hover:text-white">
                                                                    <nestedItem.icon className="h-4 w-4 mr-3" />
                                                                    <span>{nestedItem.text}</span>
                                                                </NavLink>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className="p-1 border-t border-blue-700">
                <button
                    onClick={handleLogout}
                    className="flex items-center w-full p-3 rounded-lg text-red-300 hover:bg-red-600 hover:text-white transition-all duration-200 ease-in-out"
                >
                    <FaSignOutAlt className={`h-5 w-5 ${isSidebarOpen ? 'mr-3' : 'mx-auto'}`} />
                    <span className={`${isSidebarOpen ? 'opacity-100' : 'opacity-0 w-0'} transition-all duration-200`}>
                        Cerrar sesión
                    </span>
                </button>
            </div>
        </div>
    );
}

export default Sidebar;
